import React, { createContext, useContext, useState, useEffect } from "react";
import { authAPI } from "../services/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("sava_admin_user");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setUser(parsed);
        authAPI.me()
          .then(({ data }) => setUser((u) => ({ ...u, ...data.user })))
          .catch(() => { localStorage.removeItem("sava_admin_user"); setUser(null); });
      } catch { localStorage.removeItem("sava_admin_user"); }
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const { data } = await authAPI.login({ username, password });
      const userData = { ...data.user, token: data.token };
      setUser(userData);
      localStorage.setItem("sava_admin_user", JSON.stringify(userData));
      return { success: true };
    } catch (err) {
      return { success: false, message: err.response?.data?.error || "Login failed" };
    }
  };

  const logout = () => { setUser(null); localStorage.removeItem("sava_admin_user"); };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
